module.exports = __webpack_public_path__ + "static/media/link_chain.b895a29c.webp";